// Testimonial Rotator — clicking a dot swaps the active quote.
import jQuery from "jquery";

jQuery(function ($) {
	'use strict';

	$('[data-p360-rotator]').each(function () {
		var root = this;
		var dots = $(root).find('.testimonial-rotator__dot');
		var quotes = $(root).find('.testimonial-rotator__quote');

		if (!dots.length) {
			return; // single quote, no dots rendered — nothing to wire up
		}

		dots.on('click', function () {
			var $dot = $(this);
			if ($dot.hasClass('is-active')) {
				return;
			}

			var target = $dot.data('quote-target');

			dots.removeClass('is-active').attr('aria-selected', 'false');
			$dot.addClass('is-active').attr('aria-selected', 'true');

			quotes.removeClass('is-active').attr('aria-hidden', 'true');
			$(root)
				.find('#' + target)
				.addClass('is-active')
				.attr('aria-hidden', 'false');
		});
	});
});